module.exports = __webpack_public_path__ + "static/media/background.12dd0aa1.png";